/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Fix for mini cart close button - Capture Phase
document.addEventListener('DOMContentLoaded', function () {
    // Use capture phase (true) to intercept clicks before they reach the theme's handlers
    document.addEventListener('click', function (e) {
        // Check if we clicked the close icon (secondary state)
        // We check for the SVG or the span wrapper
        const closeIcon = e.target.closest('.header__cart-icon .icon-state__secondary');

        // If we clicked the close icon, we want to force close the cart
        if (closeIcon) {
            console.log('Intercepted close button click');

            // 1. Stop the event from doing anything else (like scrolling or triggering buggy theme logic)
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // 2. Fix ARIA error: "Blocked aria-hidden on an element because its descendant retained focus"
            // We must remove focus from the button before the cart gets hidden
            if (document.activeElement) {
                document.activeElement.blur();
            }

            console.log('Forcing close via outside click simulation');

            // 3. Simulate a click on the document body to trigger the theme's "click outside" handler
            // This handler (_onWindowClick) is known to work correctly
            const clickEvent = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: true
            });
            document.body.dispatchEvent(clickEvent);
        }
    }, true);


});
